import { format } from 'date-fns-tz'

const getToday = () => {
  return format(new Date(), 'yyyy-MM-dd')
}

export { getToday }

// TODO convert to safari and need to global search and add fixes in for safari since it can't use ISO properly without replacing some string values
